<div [title]="title | translate">
  <div class="d-flex justify-content-between align-items-center mb-5 flex-wrap">
    <h2 class="card-heading mb-0">{{ title | translate }}{{displayResultType}}{{addSuffix ? ('count_status.result' | translate) : ''}}</h2>
    <span *ngIf="updated && hasRegisteredResults">
        {{ 'count_status.updated' | translate:{ date: updatedTime } }}
      </span>
  </div>
  <span *ngIf="!hasRegisteredResults">{{ 'count_status.no_results_registered' | translate }}</span>
  <ng-container *ngIf="hasRegisteredResults">
    <ng-container *ngIf="resultSummary !== undefined; else simpleSummary">
      <valg-dk-result-summary [resultSummary]="resultSummary"></valg-dk-result-summary>
    </ng-container>
    <ng-template #simpleSummary>
      <valg-dk-simple-result-summary [resultType]="resultType"></valg-dk-simple-result-summary>
    </ng-template>
    <ng-container *ngFor="let status of data; let first = first">
      <hr *ngIf="!first" class="my-0">
      <valg-dk-bar-chart *ngIf="status.percentage !== undefined" [percentage]="status.percentage" class="d-block my-205">
        <ng-container *ngIf="isNavigation; else notNavigation">
          <a [routerLink]="[prefixUrl, status.id]" [attr.aria-label]="status.name | translate">
            {{ status.name | translate }}
        </a>
        </ng-container>
        <ng-template #notNavigation>
          {{ status.name | translate }}
        </ng-template>
      </valg-dk-bar-chart>
    </ng-container>
  </ng-container>
</div>
